'use strict'

//Project to extend speeches in Amazon Sumerian
// Modified from code written by
//Martin Huang
//https://github.com/MHuangCode/ExtendedSpeeches-AmazonSumerian

//Speeches can be marked with gesture marks in Sumerian to trigger gestures/emotes for host.
//The editor has a function for marks to be auto-generated with a click of a button!
//But there is no function that does this during play/real-time.

//This project is an attempt to address this and extend upon the same function by including several
//other languages.


export const amiraGestures = {
    Applauds: "Applauds",
    ApplaudsSubtle: "ApplaudsSubtle",
    ArmsCrossed: "ArmsCrossed",
    CountContinue: "CountContinue",
    CountEnd: "CountEnd",
    CountStart: "CountStart",
    Counts: "Counts",
    FingersSweepDown: "FingersSweepDown",
    FingersSweepDownLeft: "FingersSweepDownLeft",
    HandToEar: "HandToEar",
    Idle: "Idle",
    IdleLonger: "IdleLonger",
    Idle_2: "Idle_folder/Idle_2",
    Idle_Blink: "Idle_folder/Idle_Blink",
    Idle_Breathing: "Idle_folder/Idle_Breathing",
    Idle_HairAdjust: "Idle_folder/Idle_HairAdjust",
    Idle_ScarfAdjust: "Idle_folder/Idle_ScarfAdjust",
    Glance_Beginning: "Glance_Beginning",
    Glance_Blink_loop: "Glance_Blink_loop",
    Glance_End: "Glance_End",
    Glance_Idle: "Glance_Idle",
    Glance_Nod_loop: "Glance_Nod_loop",
    Ok: "Ok",
    OneHandHalt: "OneHandHalt",
    PalmDown: "PalmDown",
    PointsDownAndOutLeft: "PointsDownAndOutLeft",
    Quiet: "Quiet",
    SlowClap: "SlowClap",
    SlowClapSubtle: "SlowClapSubtle",
    StartUp: "StartUp",
    StartUpLeft: "StartUpLeft",
    SweepWave: "SweepWave",
    SweepWaveLeft: "SweepWaveLeft",
    TapContinue: "TapContinue",
    TapEnd: "TapEnd",
    TapIt: "TapIt",
    TapStart: "TapStart",
    TapOnWatch: "TapOnWatch",
    Thinking: "Thinking",
    ThumbsUp: "ThumbsUp",
    ThumbsUpWink: "ThumbsUpWink",
    TwoHandedUpwardSweep: "TwoHandedUpwardSweep",
    Wave: "Wave",
    Excited: "Excited",
    Excited_nomouth: "Excited_nomouth",
    Exasperated: "Exasperated",
    Exasperated_long: "Exasperated_long",
    Exasperated_nomouth: "Exasperated_nomouth",
    Facepalm: "Facepalm",
    Facepalm_nomouth: "Facepalm_nomouth",
    Playful: "Playful",
    Playful_nomouth: "Playful_nomouth",
    Eyebrows_excitement: "Eyebrows_excitement",
    Eyebrows_neutral: "Eyebrows_neutral",
    TheRenegadeDance_short: "TheRenegadeDance_short",
    Playful_to_Facepalm: "Playful_to_Facepalm",
    Exasperated_to_Wave: "Exasperated_to_Wave",
    WideEyes_nomouth: "WideEyes_nomouth",
    WideEyes: "WideEyes",
    point_01: "point_01", //TODO re-instate this when it is fixed by primal
    point_03: "point_03", // not found
    PointingWithChalk: "PointingWithChalk",
    PointingWithChalkLeft: "PointingWithChalkLeft",

    Marketing_Sc1: "Marketing_Sc1",
  //   Marketing_Sc2: "Marketing_Sc2", Not available for use currently
    Marketing_Sc3: "Marketing_Sc3",
    Marketing_Sc4: "Marketing_Sc4",
    Marketing_Sc_Alt1: "Marketing_Sc_Alt1",
    Marketing_Sc_Alt2: "Marketing_Sc_Alt2",
    Marketing_Sc_Alt3: "Marketing_Sc_Alt3",


    _Pure_rig: "_Pure_rig",


    //DANCES
    TheFlossDance: "TheFlossDance",
    TheFunkyChicken: "TheFunkyChicken",
    TheRenegadeDance: "TheRenegadeDance",
  };
//english word map from create.js
const mappingEnglish = [{
    //gesture: 'agreement',
    gesture: amiraGestures.thumbs_up,
    words: 'agree, agrees, agreed, join, joined, joins, joining, partner, partnered, partners, partnering, relationship, share, shared, sharing, shares, together, togetherness, linked, links, link, linking'
  },
  {
    gesture: amiraGestures.wave,
    words: 'hello, hi, hiya, howdy, welcome, aloha, heya, hey, goodbye, bye, goodbye, hola, adios, chao'
  },
  {
    gesture: amiraGestures.applaud,
    words: 'great, awesome'
  },
  {
    gesture: amiraGestures.startup,
    words: 'keep'
  },
  {
    gesture: amiraGestures.sweep_wave,
    words: 'turn'
  },
  {
    gesture: amiraGestures.count_three,
    words: 'three'
  }
/*
  {
    gesture: 'big',
    words: 'add, above, authority, big, cover, full, fly, grow, growth, high, huge, increase, major, majority, large, leader, lot, raise, rise, tall'

}, {
    gesture: 'heart',
    words: 'accept, admit, believe, care, feeling, feel, friend, grateful, happy, heart, human, pain, save, safe, kind, love'

}, {
    gesture: 'in',
    words: 'include, including, inside, into, now, near, nearest, closest, therein, within'

}, {
    gesture: 'many',
    words: 'all, always, any, anyone, among, area, any, around, beautiful, entire, environment, environments, environmental, everybody, everyone, everything, audience, total, group, groups, million, millions, others, billion, billions, hundred, hundreds, many, thousand, thousands, world, worlds, outside, reveal'

}, {
    gesture: 'movement',
    words: 'away, across, ahead, along, far, fast, follow, go, leave, move, movement, through, throughout, toward, travel, turned, passed'

}, {
    gesture: 'one',
    words: 'single, one, once, first, firstly, only, solo, warned, truly, up, alone'

}, {
    gesture: 'aggressive',
    words: 'power, powers, powerful, assert, assertive, strong, stronger, strongest, strength, flex, dang, damn, damnit, darn, shucks, doh, drat, angry, angrier, angriest, aggressive, annoyed, annoying, attack, attacking, offense, offensive, battle'

}, {
    gesture: 'you',
    words: "you, yall, y'all, your, yours, thou, thy"

}, {
    gesture: 'defense',
    words: 'defense, fear, repulsed, scared, scary, scarier, scariest, fearful, afraid, cower, cowers, cowering, hideous, doomed, terrified, terrify, terrifying terrifies, spooky, spookier, spookiest'

},  {
    gesture: 'self',
    words: "my, i, myself, self, i've, Ive, me, mine"

}, {
    gesture: 'negative',
    words: 'disgust, disgusted, gross, vile, ugly, eew, slimey, creepy, done, nasty, enough, without, never, nevermore, wont, wouldnt, shouldnt, dont, no, nope, none, never, nothing, nada'
}*/
];

const mappingFrench = [{
    gesture: 'big',
    words: 'ajouter, ci-dessus, autorité, grand, couverture, plein, mouche, grandir, croissance, haute, énorme, augmentation, majeur, majorité, grand, chef de file, beaucoup, élever, monter, grand'
}, {
    gesture: 'heart',
    words: "accepter, admettre, croire, prendre soin, se sentir, se sentir, ami, reconnaissant, heureux, coeur, humain, douleur, sauver, sûr, gentil, aimer"

}, {
    gesture: 'in',
    words: "inclure, y compris, à l'intérieur, dans, maintenant, près, le plus proche, le plus proche, dedans"

}, {
    gesture: 'many',
    words: "tous, toujours, n'importe qui, parmi, zone, tout autour, beau, ensemble, environnement, environnements, environnement, tout le monde, tout le monde, tout, public, total, groupes, millions, millions, autres, milliards, cent, centaines, beaucoup, mille, milliers, monde, monde, dehors, révélez"

}, {
    gesture: 'movement',
    words: 'loin, à travers, en avant, le long, loin, vite, suivre, aller, partir, déplacer, mouvement, à travers, tout au long, vers, voyager, tourné, passé'

}, {
    gesture: 'one',
    words: 'single, one, one, first, firstly, only, seul, averti, vraiment, haut, seul'

}, {
    gesture: 'aggressive',
    words: 'pouvoir, pouvoirs, puissant, affirmer, assertif, fort, plus fort, plus fort, force, flex, dang, putain, damnit, darn, shucks, doh, drat, en colère, plus en colère, angriest, agressif, agacé, ennuyeux, attaque, attaquer offensive, offensive, bataille'

}, {
    gesture: 'you',
    words: "toi, yall, y'all"

}, {
    gesture: 'defense',
    words: 'défense, peur, repoussé, effrayé, effrayant, effrayant, effrayant, peureux, effrayé, recroquevillé, recroquevillé, recroquevillé, hideux, condamné, terrifié, terrifiant, terrifiant terrifie, effrayant, spookier, spookiest'

}, {
    gesture: 'wave',
    words: 'bonjour, salut, hiya, howdy, bienvenue, aloha, heya, hé, au revoir, au revoir, bye, hola, adios, chao'

}, {
    gesture: 'self',
    words: "mon, moi, moi-même, j'ai, le mien"

}, {
    gesture: 'agreement',
    words: "d'accord, de rejoindre, rejoint, rejoindre, partenaire, partenaire, partenaires, partenariat, relation, partager, partagé, partage, part, ensemble, togetherness, lié, liens, link, linking"

}, {
    gesture: 'negative',
    words: 'dégoût, dégoûté, grossier, vil, laid, eew, slimey, creepy, fait, méchant, assez, sans, jamais, nevermore, ne veut pas, ne pas, non, aucun, jamais, rien, nada'
}];
//////////////
const mappingSpanish = [{
    gesture: 'big',
    words: 'añadir, por encima, la autoridad, grande, cubierta, llena, volar, crecer, crecimiento, enorme, aumento, mayor, líder, mucho, subir, subida, alto '
}, {
    gesture: 'heart',
    words: 'aceptar, admitir, creer, la atención, la sensación, sentir, amigo, agradecido, feliz, corazón, humano, dolor, salvar, seguro, amable,amor'
}, {
    gesture: 'in',
    words: 'incluirá, entre ellos, en el interior, en, ahora, cerca, más cerca, en la misma, dentrode'

}, {
    gesture: 'many',
    words: 'todos, siempre, cualquier, cualquier persona, entre, área, cualesquiera, alrededor de, hermoso, enteras, ambiente, ambientes, del medio ambiente, todo el mundo, cada uno, todo, audiencia, en total, grupo, grupos, otros, mil, millones, mil millones cientos, cientos, muchos, miles, mundo, mundos, exterior,revelan'

}, {
    gesture: 'movement',
    words: 'de distancia, al otro lado, por delante, a lo largo, lejos, rápido, seguir, salir, movimiento, a través de, hacia, viajes, se volvió, pasó'

}, {
    gesture: 'one',
    words: 'individual, una, vez, en primer lugar, solamente, solo, advirtió, en verdad,sola'

}, {
    gesture: 'aggressive',
    words: 'poder, poderes, potente, afirman, firme, fuerte, fuerza, flexibilidad, Dang, maldita sea, maldita, caramba, DOH, drat, enojado, más enojado, agresivo, molestado, molestia, ataque, atacando ofensiva, ofensivo, batalla'

}, {
    gesture: 'you',
    words: "usted, yall, todos ustedes, su, el suyo, tú, tu"

}, {
    gesture: 'defense',
    words: 'defensa, repulsión, miedo, más miedo, más temible, temeroso, con miedo, se encogen, se encoge, encogido, horrible, condenado, aterrado, aterrorizar, aterrador aterroriza, fantasmagórico, fantasmagóricos, spookiest'

}, {
    gesture: 'wave',
    words: 'hola, hiya, ¡Hola, bienvenido, hawaiana, heya, bueno, adiós, chao'

}, {
    gesture: 'self',
    words: "i, yo, sí, tengo, he, mi, mío "

}, {
    gesture: 'negative',
    words: 'asco, disgustado, bruto, vil, fea, eew, viscosa, espeluznante, hecho, desagradable, suficiente, sin, nunca, nunca más, costumbre, wouldnt, shouldnt, no haga, pues no, no, nada'
}];

const mappingRussian = [{

    gesture: 'big',
    words: 'добавить, выше, власть, большое, покрытие, полный, летать, рост, высокое, огромное, увеличение, майор, большинство, большой, лидер, много, поднять, расти, высокий'

}, {
    gesture: 'heart',
    words: 'принять, признать, поверьте, уход, чувство, чувствовать друг, благодарный, счастливый, сердце, человека, боль, сохранить, сейф, вид, любовь'

}, {
    gesture: 'in',
    words: 'включаютсебя,том числе, внутри, в, теперь, рядом, ближайший, ближе,ней,пределах'

}, {
    gesture: 'many',
    words: 'все, всегда, любой, кто, среди, области, любые, вокруг, красивая, вся, окружающая среда, экологические, зрители, всего, группы, миллионы, другие, миллиард, миллиарды сто, сотни, много, тысячи, мир, миры,улице, показывают'

}, {
    gesture: 'movement',
    words: 'далеко, поперек, вперед, быстро следовать, идти, уходить, движение, через,всему, к, путешествия, повернулся, прошел'

}, {
    gesture: 'one',
    words: 'сингл, один, однажды,первых, вопервых, только соло, предупреждала, действительно, вверх,одиночку'

}, {
    gesture: 'aggressive',
    words: 'власть, полномочие, мощное, утверждает, напористым, сильным, сильное, сила, сгибать, Данг, черт, черт побери, штопка, лузга, DOH, убирайтесь, сердится, злее, angriest, агрессивное, раздраженное, раздражающее, нападение, атакуя преступление, наступление, бой'

}, {
    gesture: 'you',
    words: "вы, Yall, y'all, ваш, ваша, ты, твой"

}, {
    gesture: 'defense',
    words: 'оборона, страх, отбиты, страшно, страшней, страшный, боясь, приседать, съеживается, съежившись, отвратительный, обречено, ужас, ужасает, ужасает ужас, похожийпривидение'

}, {
    gesture: 'wave',
    words: 'здравствуйте, Привет, привет, хия, здор`ово, добро пожаловать, Алоха, Хэя, эй, до свидания, Голя, прощай, чао'

}, {
    gesture: 'self',
    words: "боже, я, Ive, мне, мое"

}, {
    gesture: 'agreement',
    words: 'согласен, соглашается, согласился присоединиться, присоединились, присоединяется, присоединение, партнера, партнеров, отношения, общие, обмен, акция, вместе, единение, связаны между, ссылки'

}, {
    gesture: 'negative',
    words: 'отвращение, валовые, мерзкий, некрасивый, ЭВП, жуткое, сделано, неприятный, достаточно, не, никогда больше, привычка, должны, не нет, Нету, ни, никогда, ничего, нада'
}];
/////////////////
const mappingJapanese = [{
    gesture: 'big',
    words: '上記の, 権限を追加し, フル大きい, カバー, 飛ぶ, 成長, 高, 巨大な,  主要な, 大多数, 大, リーダー, たくさん, 上げ, 上昇, 背の高いです'
}, {
    gesture: 'heart',
    words: '受け入れを認める, と信じて, ケア, 感情, 感じ, 友人, 感謝し, 幸せ, 心, 人間, 痛み, 保存, 安全, 親切, 愛'
}, {
    gesture: 'in',
    words: '内部を含めに, 今, 近く, 最も近い, その中に, 内部に含まれます'
}, {
    gesture: 'many',
    words: 'すべて, 常に, 任意の, だれでも, エリア, のうち, いずれかの周りに, 美しく, 全体の, 環境, 誰も, 誰もが, すべてのもの, 観客, 合計, グループ, 百万, 何百万人, 他の人, 十億, 数十億, 百, 数百, 数千, 数千人, 世界, 世界は, 外で明らかにし'
}, {
    gesture: 'movement',
    words: '残し, 行く, 続く, 離れて, 間, 先に, に沿って, 遠く, 速い, 動き, 運動を通して, 全体に, 旅行に向かって, 渡され, 投入'
}, {
    gesture: 'one',
    words: '一度, 第一, まず, 唯一, ソロ, 単独で, 真に, アップ, 警告, 一つの単一'
}, {
    gesture: 'aggressive',
    words: 'パワー, 強力, 主張, 自己主張, 強い, 最強, 強さ, フレックス, 一顧, いまいましい, くそ, 怒り, 積極的な, イライラ, 迷惑な, 攻撃, 戦闘'
}, {
    gesture: 'you',
    words: "ヤオール, y'allの, あなた, あなたの"
}, {
    gesture: 'defense',
    words: '防衛, 撃退, 怖い, 恐れ, 萎縮, cowers, 戦慄, 恐ろしい, 運命, 恐怖, 恐怖に陥れるに恐ろしい, 幽霊, すごい、恐るべき'
}, {
    gesture: 'wave',
    words: 'adios, オラ, さようなら, ちょっと, へや, アロハ, 歓迎, こんにちは, hiya, HI, ハロー, チャオ'
}, {
    gesture: 'self',
    words: "自己, 私は, アイブ, 私, 鉱山をしました"
}, {
    gesture: 'agreement',
    words: '同意する, 同意し, 参加, 結合, 接合, パートナー, 関係, 共有, 一緒に, 一緒, リンクされ, リンク'
}, {
    gesture: 'negative',
    words: '嫌悪感, 総, 下劣な, 醜い, EEW, slimey, 不気味な, 行って, 厄介な, 十分に, なし, 決して, ネヴァーモア, 文句を言わない, はずの, いけない, いや, どれも, 何も, 灘'
}];
///////////////
const mappingKorean = [{
    gesture: 'big',
    words: '비행, 전체, 위의, 성장, 높은, 거대한, 증가, 주요, 대부분의 큰 지도자, 많이, 인상, 상승, 키를 권한, 큰, 커버를 추가'
}, {
    gesture: 'heart',
    words: '저장, 기분, 느낌,주의, 인정 믿고, 친구, 감사, 행복, 심장, 인간의 고통을 받아 안전하고, 친절하고, 사랑'
}, {
    gesture: 'in',
    words: '내 안에, 가장 가까운, 근처, 지금으로, 내부, 포함'
}, {
    gesture: 'many',
    words: '모든, 항상, 어떤, 사람, 지역, 중, 어떤 약, 아름다운, 전체, 환경, 모든 사람, 모든 관객, 총, 그룹, 만, 수백만, 다른 사람, 억, 백, 몇 천, 천, 세계, 세계는, 외부, 공개'
}, {
    gesture: 'movement',
    words: '멀리,에서, 앞서, 함께, 빠르고, 여행, 대한 전역을 통해 이동, 운동, 이동에 따라 떠날 켜져 통과'
}, {
    gesture: 'one',
    words: '하나의, 한 번, 첫째, 단지, 솔로, 경고, 진정, 위, 혼자'
}, {
    gesture: 'aggressive',
    words: '힘은 강력하고, 강하고, 강한, 힘, 플렉스, DOH 문제 발생, 망할, 젠장, drat, 화나게, 제일 많이, 공격적, 화가, 성가신 공격을 주장 강력한 주장 공격 공격, 공격, 전투'
}, {
    gesture: 'you',
    words: "yall를, 모두들, 당신의, 당신, 그대, 네"
}, {
    gesture: 'defense',
    words: '방어, 두려움, 격퇴, 무서워, 무서운는 두려움, 걱정, 겁쟁이, 위축, 무시 무시한, 운명, 겁에 질린, 무섭게, 유령을, 초라한, 무서운, 겁'
}, {
    gesture: 'wave',
    words: '여보세요, heya, 알로하, 안녕, 차오'
}, {
    gesture: 'self',
    words: "내, 내가, 나 자신, 자기, 난, 필자 나, 내했습니다"
}, {
    gesture: 'agreement',
    words: '동의, 가입, 결합, 파트너, 파트너 관계, 관계, 공유, 함께, 공생, 링크'
}, {
    gesture: 'negative',
    words: '혐오, 총, 비열한, 추한, EEW, 저런, 소 름, 수행, 불쾌한, 충분하지 않고, 결코, 그 뿐이었다, 습관, 야해, 그나마, 아니, 전혀, 아무것도, 아무것도 모르는'
}];

const genericGestures = [amiraGestures.clap, amiraGestures.two_hand_sweep, amiraGestures.sweep_wave, amiraGestures.point_down, amiraGestures.thumbs_up, amiraGestures.palm_down, amiraGestures.startup];

const languageMap = {
    "en": mappingEnglish,
    "fr": mappingFrench,
    "es": mappingSpanish,
    "ru": mappingRussian,
    "jp": mappingJapanese,
    "kr": mappingKorean
};

const languageNames = {
    "en": 'English',
    "fr": 'French',
    "es": 'Spanish',
    "ru": 'Russian',
    "jp": 'Japanese',
    "kr": 'Korean'
}

const asianLanguage = ["jp", "kr"];

const femaleVoices = {
    "en": "Salli",
    "fr": "Celine",
    "es": "Penelope",
    "ru": "Tatyana",
    "jp": "Mizuki",
    "kr": "Seoyeon"
};

const maleVoices = {
    "en": "Justin",
    "fr": "Mathieu",
    "es": "Miguel",
    "ru": "Maxim",
    "jp": "Takumi"
}

const genders = {
    'male': maleVoices,
    'female': femaleVoices
};

const voices = [
    'Aditi',
    'Amy',
    'Astrid',
    'Brian',
    'Carla',
    'Carmen',
    'Celine',
    'Chantal',
    'Conchita',
    'Cristiano',
    'Dora',
    'Emma',
    'Enrique',
    'Ewa',
    'Filiz',
    'Geraint',
    'Giorgio',
    'Gwyneth',
    'Hans',
    'Ines',
    'Ivy',
    'Jacek',
    'Jan',
    'Joanna',
    'Joey',
    'Justin',
    'Karl',
    'Kendra',
    'Kimberly',
    'Liv',
    'Lotte',
    'Mads',
    'Maja',
    'Marlene',
    'Mathieu',
    'Matthew',
    'Maxim',
    'Miguel',
    'Mizuki',
    'Naja',
    'Nicole',
    'Penelope',
    'Raveena',
    'Ricardo',
    'Ruben',
    'Russell',
    'Salli',
    'Seoyeon',
    'Takumi',
    'Tatyana',
    'Vicki',
    'Vitoria'
];

export function getAllGestures(){
  let outString = "Here are all my gestures. ";

  Object.keys(amiraGestures).map(function(key, index) {
    outString += '<mark name="gesture:' + amiraGestures[key] + '"/>' + ' ' + amiraGestures[key] + ' <break time=\"2s\"/>';
  });

  outString = '<speak>' + outString + '</speak>';
  console.log("gestures:",outString);
  return outString;
}



const whitespaceRegex = /\s+/g;
const punctuationRegex = /[\.。,、\\\/\#\?？¡!!$%^&*;:{}\=\-\_`~()\[\]"']+/g;
const sentenceEndRegex = /[.。!!?？]$/;
const sentenceEndRegexAsian = /[.。!!?？]/g;
const markRegex = /<[^>]*>/g;

function spliceString(str, start, newSubString) {
    return str.slice(0, start) + newSubString + str.slice(start);
}

function replaceWordAt(str, word, index) {
    let endIndex = index + word.length;
    let replaceWith = "-".repeat(word.length);
    return str.slice(0, index) + str.slice(index, endIndex).replace(word, replaceWith) + str.slice(endIndex);
}

function replaceCharAt(str, character, index) {
    let endIndex = index + 1;
    return str.slice(0, index) + character + str.slice(endIndex);
};


function removeElement(array, from, to) {
    let rest = array.slice((to || from) + 1 || array.length);
    array.length = from < 0 ? array.length + from : from;
    return array.push.apply(array, rest);
}

function getRandomGenericGesture() {
    let i = Math.floor(Math.random() * genericGestures.length);
    return genericGestures[i];
}


//main function
export function genSpeechGestures(speech, language) {
    let map = languageMap[language];

    if (asianLanguage.indexOf(language) > -1) {
        speech = genSpeechGesturesAsian(speech, map);
    } else {
        speech = genSpeechGesturesWestern(speech, map);
    }

    return speech;
}

function getAsianSentences(speech) {
    let sentenceStart = 0;
    let sentenceEnd = speech.search(sentenceEndRegexAsian, 0);
    let sentences = [];

    while (sentenceEnd > -1) {
        sentences.push({
            start: sentenceStart,
            end: sentenceEnd
        });
        sentenceStart = sentenceEnd + 1;
        speech = replaceCharAt(speech, "-", sentenceEnd);
        sentenceEnd = speech.search(sentenceEndRegexAsian, 0);
    }

    if (sentenceEnd != speech.length) {
        sentences.push({
            start: sentenceStart,
            end: speech.length
        });
    }

    return sentences;
}

//since asian words do not have whitespace in between each other
//we will use index of to get a good guess of where and if there
//is a valid word
function genSpeechGesturesAsian(speech, map) {

    let gesturesToAdd = new Map();
    let indicies = [];

    let speechText = speech.replace(markRegex, '');
    let dirtyText = speechText;

    let sentences = getAsianSentences(speech);


    for (let i = 0; i < map.length; i++) {
        let gesture = map[i].gesture;
        let words = map[i].words.split(',');

        for (let ii = 0; ii < words.length; ii++) {
            let trimmedWord = words[ii].trim();
            let index = dirtyText.indexOf(trimmedWord);

            //need to keep check that there are not more than 1 gesture per word
            while (index > -1 && indicies.indexOf(index) == -1) {
                indicies.push(index);
                gesturesToAdd.set(index, gesture);

                for (let iii = 0; iii < sentences.length; iii++) {
                    let start = sentences[iii].start;
                    let end = sentences[iii].end;

                    //Set sentence marked if it isn't already.
                    if (index >= start && index <= end) {
                        sentences = removeElement(sentences, iii, iii + 1);
                        break;
                    }
                }

                dirtyText = replaceWordAt(dirtyText, trimmedWord, index);
                index = dirtyText.indexOf(trimmedWord);
            }
        }
    }

    //Check if each sentence has a gesture, if not find a random one
    for (let i = 0; i < sentences.length; i++) {
        let index = sentences[i].start;
        let randomGesture = getRandomGenericGesture();
        indicies.push(index);
        gesturesToAdd.set(index, randomGesture);

    }

    //Sort from right to left of the positions where gesture marks should be inserted
    //We do this because if it is not sorted this way gesture marks may be inserted within
    //gesture marks
    indicies.sort(function (a, b) {
        return b - a;
    });

    for (let i = 0; i < indicies.length; i++) {
        let index = indicies[i];
        let gesture = gesturesToAdd.get(index);

        let gestureMark = '<mark name="gesture:' + gesture + '"/>';

        speechText = spliceString(speechText, index, gestureMark);
    }

    speech = '<speak>' + speechText + '</speak>';

    return speech;
}

//Since western languages have whitespaces we can use that as a marker
//for each word.
//Similar logic from create.js in sumerian when clicking on auto-generate
//speech gestures for speeches in the editior. Only difference is the searching method.
//Credits to the AWS Sumerian team.
function genSpeechGesturesWestern(speech, map) {

    //remove any gesture & ssml marks from speech
    let speechText = speech.replace(markRegex, '');

    let gesturedSentences = [];
    let bIsMarkedSentence = false;
    let currentSentence = [];

    //make an array of white space in text, will be added back when reassembling text
    let whitespace = speech.match(whitespaceRegex);

    //Prevent whitespace array from being defined as null when only a single word is entered.
    if (whitespace == null) {
        whitespace = [];
    }

    let whitespaceIndex = 0;

    let speechWords = speechText.split(whitespaceRegex);

    let newGestures = getGestureForWords(speechWords, map);

    for (let i = 0; i < speechWords.length; i++) {
        let word = speechWords[i];
        if (newGestures[i] != "null") {
            let gesture = newGestures[i];
            currentSentence.push('<mark name="gesture:' + gesture + '"/>' + word);
            bIsMarkedSentence = true;
        } else {
            currentSentence.push(word);
        }

        if (whitespaceIndex < whitespace.length) {
            currentSentence.push(whitespace[whitespaceIndex++]);
        }

        if (sentenceEndRegex.test(word)) {
            let fullSentence = addSentence(gesturedSentences, currentSentence, bIsMarkedSentence);
            gesturedSentences.push(fullSentence);

            currentSentence.length = 0;
            bIsMarkedSentence = false;
        }
    }

    //if final sentence does not have an ending punctuation
    if (currentSentence.length > 0) {

        //will check if sentence has any marks, if not add random generic one
        let fullSentence = addSentence(gesturedSentences, currentSentence, bIsMarkedSentence);
        gesturedSentences.push(fullSentence);
    }

    //add speak marks and join all sentences
    speech = '<speak>' + gesturedSentences.join('') + '</speak>';
    return speech;
}


//Faster searching for gestures
function getGestureForWords(words, map) {

    let cleanedWords = [];
    let gesturesToAdd = [];

    for (let i = 0; i < words.length; i++) {
        let word = words[i];
        let unPunctuationWord = word.replace(punctuationRegex, '');
        let lowercaseWord = unPunctuationWord.toLowerCase();
        let trimmedWord = lowercaseWord.trim();

        cleanedWords.push(trimmedWord);

        gesturesToAdd.push('null');
    }

    for (let i = 0; i < map.length; i++) {
        let gesture = map[i].gesture;
        let compareArray = map[i].words.split(',');

        for (let ii = 0; ii < compareArray.length; ii++) {
            let compare = compareArray[ii];
            compare = compare.trim();
            let index = cleanedWords.indexOf(compare);

            if (index > -1) {
                gesturesToAdd[index] = gesture;
                break;
            }
        }
    }

    return gesturesToAdd;
}


//Credit to the AWS Sumerian team
//returns joined sentence of gestured marks, words, and whitespaces
//if a speech is not marked then add a generic mark so host does not
//stand there like a robot the whole time.
function addSentence(speech, sentence, marked) {

    if (!marked) {
        let gesture = getRandomGenericGesture();
        let newSentence = '<mark name="gesture:' + gesture + '"/>';
        speech.push(newSentence);
    }

    speech.push(sentence.join(''));

    return speech;
}

//custom object to create gestured speeches
/*
sumerian.gesturedSpeech = function () {
    this.speech = new sumerian.Speech();
    this.speechBody = "";
    this.gesturedBody = "";
    this.configured = false;
    this.wordIndex = -2;
    this.configureSpeech = function (speechText, language, host, autoGesture, voice) {

        host.getComponent('SpeechComponent').addSpeech(this.speech);

        let outputSpeech = speechText;
        let gender = 'female';

        if (voice && voice.gender) {
            gender = voice.gender;
        }

        try {
            if (!genders.hasOwnProperty(gender)) {
                throw Error('Invalid voice gender: ' + gender);
            }
        } catch (e) {
            console.error(e);
            return;
        }

        let voiceArray = genders[gender];

        try {
            if (!voiceArray.hasOwnProperty(language)) {
                throw Error('No valid voice for this language and gender combination: ' + languageNames[language] + ", " + gender);
            }
        } catch (e) {
            console.error(e);
            return;
        }

        let pollyVoice = voiceArray[language];

        if (voice && voice.pollyName) {
            pollyVoice = voice.pollyName;
        }

        try {
            if (!languageMap.hasOwnProperty(language)) {
                throw Error('Invalid language: ' + language);
            }

            if (voices.indexOf(pollyVoice) == -1) {
                throw Error('Invalid voice ID: ' + pollyVoice);
            }

            if (outputSpeech.length < 1) {
                throw Error('Length of speech text body < 1');
            }

        } catch (e) {
            console.error(e);
            return;
        }

        if (autoGesture) {
            outputSpeech = genSpeechGestures(speechText, language);
        }

        this.speech.updateConfig({
            entity: host,
            body: outputSpeech,
            voice: pollyVoice
        });

        this.speechBody = speechText;
        this.gesturedBody = outputSpeech;
        this.configured = true;
        this.wordIndex = -2;
    };

    this.play = function () {
        try {
            if (!this.configured) {
                throw Error('Unconfigured speech, please configure before play attempt');
            }

            this.speech.play();
        } catch (e) {
            console.error(e);
            return;
        }
    };

    this.stop = function () {
        try {
            if (!this.configured) {
                throw Error('Unconfigured speech, please configure before stop attempt');
            }

            this.speech.stop(true);
            this.wordIndex = -1;
        } catch (e) {
            console.error(e);
            return;
        }
    };

    this.pause = function () {
        try {
            if (!this.configured) {
                throw Error('Unconfigured speech, please configure before pause attempt');
            }

            this.speech.stop(false);
        } catch (e) {
            console.error(e);
            return;
        }
    };

    this.restart = function() {
        try {
            if (!this.configured) {
                throw Error('Unconfigured speech, please configure before pause attempt');
            }

            this.stop();
            this.play();
        } catch(e) {
            console.error(e);
            return;
        }
    };

    this.getSentences = function(){
        return this.speech._speechMarks.sentence;
    };

    this.getWordIndex = function() {
        return this.speech._currentWordMarkIndex;
    };

    this.getWords = function() {
        return this.speech._speechMarks.word;
    };

    this.getCurrentWord = function() {
        return this.speech._currentWord;
    };

    //No official way to check when speech has finished, but method has worked from tests.
    this.isSpeechFinished = function () {
        if (this.speech._currentWord != "") {
            if (this.wordIndex < this.speech._currentWordMarkIndex) {
                this.wordIndex = this.speech._currentWordMarkIndex;
            }
            return false;
        } else if (this.wordIndex > this.speech._currentWordMarkIndex && this.speech._currentWordMarkIndex == 0) {
            this.wordIndex = -1;
            return true;
        }

        if (this.wordIndex == -1) {
            return true;
        }

        return false;
    };
};
*/